import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../../components'
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

const CommerceTab = () => {
  const navigate = useNavigate();
  const { rol } = useSelector(store => store.session);
  return (
    <Box mt={-2}>
      <CustomTab
        base={'/cliente/comercios'}
        panels={[
          {
            name: "Distribuidores",
            route: '/cliente/comercios/distribuidores',
            onChange: () => navigate('distribuidores'),
            show: rol?.name !== 'Menudeo',
            content: <Outlet />
          },
          {
            name: "Menudeo",
            route: '/cliente/comercios/menudeo',
            onChange: () => navigate('menudeo'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default CommerceTab